import { DateTime } from 'luxon';

/**
 * Get the first item that pass the test
 * by second argument function
 *
 * @param {Array} list
 * @param {Function} f
 * @return {*}
 */
function find(list, f) {
  return list.filter(f)[0];
}

/**
 * Deep copy the given object considering circular structure.
 * This function caches all nested objects and its copies.
 * If it detects circular structure, use cached copy to avoid infinite loop.
 *
 * @param {*} obj
 * @param {Array<Object>} cache
 * @return {*}
 */
export function deepCopy(obj, cache = []) {
  // just return if obj is immutable value
  if (obj === null || typeof obj !== 'object') {
    return obj;
  }

  // if obj is hit, it is in circular structure
  const hit = find(cache, (c) => c.original === obj);
  if (hit) {
    return hit.copy;
  }

  const copy = Array.isArray(obj) ? [] : {};
  // put the copy into cache at first
  // because we want to refer it in recursive deepCopy
  cache.push({
    original: obj,
    copy,
  });

  Object.keys(obj).forEach((key) => {
    copy[key] = deepCopy(obj[key], cache);
  });

  return copy;
}

/**
 * forEach for object
 */
export function forEachValue(obj, fn) {
  Object.keys(obj).forEach((key) => fn(obj[key], key));
}

/**
 * Object をマージする
 * @param  {Object} baseObj
 * @param  {Object} margeObj
 * @return {Object}
 */
export function margeObject(baseObj, margeObj) {
  forEachValue(margeObj, (obj, key) => {
    // eslint-disable-next-line no-prototype-builtins
    if (baseObj.hasOwnProperty(key)) {
      let val = obj;
      // if (/^([1-9]\d*|0)(\.\d+)?$/.test(val)) {
      //   val = val * 1
      // }
      baseObj[key] = val;
    }
  });
  return baseObj;
}

/**
 * ObjectをParamの文字列にして返す
 * @param {Object} obj
 */
export function ObjToParam(obj) {
  let params = [];
  forEachValue(obj, (val, key) => {
    params.push(key + '=' + encodeURIComponent(obj[key]));
  });
  return params.join('&');
}

/**
 * 数値にカンマを挿入する
 * @return {Array}
 */
export function numSeparate(num) {
  return String(num).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
}

/**
 * 日付をフォーマットする
 * @param  {Date}   date     日付
 * @param  {String} [format] フォーマット
 * @return {String}          フォーマット済み日付
 */
export function formatDate(date, format) {
  if (!format) format = 'YYYY-MM-DD hh:mm:ss.SSS';
  format = format.replace(/YYYY/g, date.getFullYear());
  format = format.replace(/MM/g, ('0' + (date.getMonth() + 1)).slice(-2));
  format = format.replace(/DD/g, ('0' + date.getDate()).slice(-2));
  format = format.replace(/hh/g, ('0' + date.getHours()).slice(-2));
  format = format.replace(/mm/g, ('0' + date.getMinutes()).slice(-2));
  format = format.replace(/ss/g, ('0' + date.getSeconds()).slice(-2));
  if (format.match(/S/g)) {
    var milliSeconds = ('00' + date.getMilliseconds()).slice(-3);
    var length = format.match(/S/g).length;
    for (var i = 0; i < length; i++) format = format.replace(/S/, milliSeconds.substring(i, i + 1));
  }
  return format;
}

/**
 * getTimeTime
 * 時刻をミリ秒で返す
 *
 * @param (String} time - 時刻を00:00 - 23:59 の書式で
 * @returns {Number}
 */
export function getTimeTime(time) {
  const date = DateTime.fromISO('2000-01-02T' + time + ':00.000', { setZone: 'Asia/Tokyo' });
  return date.hour * 3600 + date.minute * 60 + date.second + date.millisecond / 1000.0;
}
